import { isNullish } from "replo-utils/lib/misc";

import useChatMessagesUsage from "./useChatMessagesUsage";

const useChatMessageLimits = ():
  | {
      hasUnlimitedMessages: true;
      messagesRemaining: null;
    }
  | {
      hasUnlimitedMessages: false;
      messagesRemaining: number;
    } => {
  const chatMessageUsage = useChatMessagesUsage();

  if (isNullish(chatMessageUsage?.maximum)) {
    return {
      hasUnlimitedMessages: true,
      messagesRemaining: null,
    };
  } else {
    const messagesRemaining =
      chatMessageUsage.maximum - chatMessageUsage.current;

    return {
      hasUnlimitedMessages: false,
      messagesRemaining,
    };
  }
};

export default useChatMessageLimits;
